import React from 'react'

const Footer = () => {
  return (
    <footer>
        <div>
            <h1>Techyy</h1>
            <p>&copy; all right reserved</p>
        </div>

        <div>
            <h5>Follow Us</h5>
            <div>
                <a href="#">Youtube</a>
                <a href="#">Instagram</a>
                <a href="#">Linkedin</a>
            </div>
        </div>
    </footer>
  )
}

export default Footer